import { Notification } from '@omnipresentgroup/design-system';

export const LeaveSettingsCutOffDayNotification = () => (
  <Notification
    id="leave-settings-cut-off-day-notification"
    title="Changes to the leave policies will not take effect until after the next cutoff day."
    intent="warning"
  />
);
